export class StpAccount {
    constructor(id, stp_clabe, status) {
        this.id = id;
        this.stp_clabe = stp_clabe;
        this.status = status;
    }
}
